import { useState } from "react";

export default function InfrastructureSection() {
  const [tab, setTab] = useState("individuals");

  function Card({ img, title, desc }) {
    return (
      <div className="glass-panel border border-white/10 p-6 rounded-2xl hover:border-[var(--accent-mint)] hover:shadow-[0_0_30px_rgba(111,248,213,0.3)] transition">
        {img && (
          <img
            src={img}
            alt={title}
            className="w-14 h-14 mb-4"
          />
        )}

        <h3 className="text-lg font-semibold">{title}</h3>

        <p className="text-[#b9e5dd] text-sm mt-2">{desc}</p>
      </div>
    );
  }

  return (
    <section className="px-6 py-20 max-w-6xl mx-auto text-white">

      {/* Title */}
      <h2 className="text-4xl md:text-5xl font-extrabold leading-tight">Fast & Scalable Infrastructure</h2>

      {/* TABS */}
      <div className="relative mt-10 inline-flex bg-white/5 rounded-xl p-1 overflow-hidden border border-white/10">

        {/* Sliding Indicator */}
        <div
          className="
            absolute top-1 bottom-1 rounded-lg bg-[var(--accent-mint)]/15 border border-[var(--accent-mint)]/40
            transition-all duration-300 ease-out
          "
          style={{
            width: "33.333%",
            transform:
              tab === "individuals"
                ? "translateX(0%)"
                : tab === "business"
                ? "translateX(100%)"
                : "translateX(200%)",
          }}
        />

        {/* TAB BUTTONS */}
        <button
          onClick={() => setTab("individuals")}
          className={`relative w-[140px] md:w-[180px] py-2 text-sm font-medium z-10 transition-all ${
            tab === "individuals" ? "text-[var(--accent-mint)]" : "text-[#8fb6ad]"
          }`}
        >
          For Individuals
        </button>

        <button
          onClick={() => setTab("business")}
          className={`relative w-[140px] md:w-[180px] py-2 text-sm font-medium z-10 transition-all ${
            tab === "business" ? "text-[var(--accent-mint)]" : "text-[#8fb6ad]"
          }`}
        >
          For Businesses
        </button>

        <button
          onClick={() => setTab("depin")}
          className={`relative w-[140px] md:w-[180px] py-2 text-sm font-medium z-10 transition-all ${
            tab === "depin" ? "text-[var(--accent-mint)]" : "text-[#8fb6ad]"
          }`}
        >
          DePIN
        </button>

      </div>

      {/* CONTENT SECTIONS */}
      <div className="mt-10">

        {/* Individuals */}
        {tab === "individuals" && (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 animate-fadeIn">
            <Card
              img="/page2/vault-logo.png"
              title="Build Your Private Data Vault"
              desc="Connect your wallets, CEX accounts, DeFi positions, market feeds, and sentiment streams into a single encrypted vault accessible only by you.Drag-and-drop modules let you build custom insight dashboards within minutes"
            />
            <Card
              img="/page2/ai-box-logo.png"
              title="Train Your Own AI"
              desc="Spin up a personal Prediction Agent (PA) in just a few steps.Choose your indicators, define risk profiles, and run backtests across years of historical data. Ideal for day traders, quants, or long-term investors."
            />
            <Card
              img="/page2/connectors-logo.png"
              title="Monetize Your Edge"
              desc="OPublish your signals to the OZORA marketplace and earn $OZO for every subscriber.Your underlying data remains private — only your intelligence becomes monetized."
            />
          </div>
        )}

        {/* Businesses */}
        {tab === "business" && (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 animate-fadeIn">
            <Card
              img="/page2/lock-image.png"
              title="Secure Enterprise Data Lake"
              desc="Ingest proprietary market data, CRM records, internal databases, and external financial feeds into a secure, permissioned data lake.All records are encrypted end-to-end and comply with SOC 2 & GDPR standards."
            />
            <Card
              img="/page2/ai-image.png"
              title="Build Custom AI Agents at Scale"
              desc="Deploy multiple Prediction Agents using dedicated GPU clusters with REST/WebSocket endpoints.Integrate outputs into your existing OMS, EMS, quant systems, or risk engines using our SDK and ultra-low-latency APIs."
            />
            <Card
              img="/page2/wallet-image.png"
              title="Turn Insights into Revenue"
              desc="License white-label dashboards, embed real-time prediction streams into your financial products, or resell curated intelligence data — all tracked and settled through $OZO."
            />
          </div>
        )}

        {/* DePIN */}
        {tab === "depin" && (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 animate-fadeIn">
            <Card
              img="/page2/data-source-image.png"
              title="Distributed Data Sourcing"
              desc="Sensor hubs, exchange oracles, market APIs, and IoT edge devices stream real-time raw data directly into the OZORA Stream Network (OSN).Redundant, geo-distributed routing ensures uninterrupted data even during node failures."
            />
            <Card
              img="/page2/data-image.png"
              title="On-Chain Validation & Aggregation"
              desc="Each data packet is time-stamped, cryptographically signed, and validated by independent nodes before being pushed into smart-contract storage.This trust-minimized pipeline ensures tamper-proof, high-integrity data for AI forecasting and on-chain analytics."
            />
            <Card
              img="/page2/atom-image.png"
              title="Edge-Ready Integration"
              desc="Real-time APIs and WebSockets deliver validated streams straight into Prediction Agents, enterprise dashboards, embedded devices, and DeFi protocols — enabling split-second algorithmic reactions and automated decision systems."
            />
          </div>
        )}

      </div>
    </section>
  );
}

/* Reusable Card Component */